<div *ngIf="!isInEditMode" class="account-manager">
  <span>{{ portfolio?.currentAccountManager?.admin?.fullName }}</span>
  <a class="btn btn-default btn-sm" (click)="onEditAccountManagerClick()"
    ><i class="fa fa-pencil fa-fw"></i
  ></a>
</div>
<div *ngIf="isInEditMode" class="account-manager">
  <select
    name="accountManagers"
    [ngModel]="accountManagers && selectedAccountManagerId"
    (ngModelChange)="accountManagers && (selectedAccountManagerId = $event)"
  >
    <option *ngFor="let item of accountManagers" [ngValue]="item?.adminId">
      {{ item?.fullName }}
    </option>
  </select>
  <a class="btn btn-default btn-sm" (click)="onUpdateAccountManagerClick()"
    ><i class="fa fa-check fa-fw"></i
  ></a>
  <a class="btn btn-default btn-sm" (click)="onCancelClick()"
    ><i class="fa fa-times fa-fw"></i
  ></a>
</div>
